export const Layout = Object.freeze({
  Row: 'row', // row means we render as rows top down. Thjis is different than felx rows!
  Grid: 'grid',
  Wrap: 'wrap',
  AutoHorizontal: 'auto-horizontal',
  AutoVertical: 'auto-vertical'
})